export default __webpack_public_path__ + "static/media/empty-box.7671cc5f.png";